import React from "react";

import { Container } from "./styles";
import Registration from "../../components/Register";

const EnrollPage = (props) => {
    return (
        <Container>
            <Registration />
        </Container>
    );
};

export default EnrollPage;
